/**
 * Mensaje para el usuario cuando falla el alta de una aportación periódica (crear el pago, guardar la aportación o
 * iniciar el cobro en Inespay): el del backend si lo envía y, si no, uno según el código de respuesta.
 * POST payments responde el motivo como texto; POST PeriodicContributions, como { errorCode, message }.
 */
export const getPeriodicContributionErrorMessage = (submitError: any): string =>
{
    const status: number | undefined = submitError?.response?.status;
    const data = submitError?.response?.data;

    if(typeof data === "string" && data.trim() !== "")
    {
        return data;
    }
    if(typeof data?.message === "string" && data.message.trim() !== "")
    {
        return data.message;
    }
    if(status === undefined)
    {
        return "No se ha podido conectar con el servidor para dar de alta la aportación periódica. Revisa tu conexión e inténtalo de nuevo.";
    }
    if(status === 401 || status === 403)
    {
        return "No tienes permiso para dar de alta esta aportación periódica o tu sesión ha caducado. Vuelve a iniciar sesión e inténtalo de nuevo.";
    }
    if(status === 404)
    {
        return "No se ha encontrado la cartera modelo de la aportación periódica.";
    }
    return `No se ha podido dar de alta la aportación periódica (error ${status}). Por favor, inténtalo de nuevo más tarde.`;
};
